<!-- C:\platforma-frontend-admin-creator\admin-site\src\views\HomePage.vue -->

<template>
  <div class="flex min-h-screen flex-col lg:flex-row ">
    <!-- Sidebar with Features -->
    <aside class="w-full lg:w-1/2 p-8 bg-white items-center">
      <h2 class="text-2xl font-bold text-gray-800 mb-6">Add a Product</h2>
      <p class="text-gray-500 text-sm mb-8">
        Explore Each Feature, then click the "Select" Button to Add Feature to Your Member Platform
      </p>
      
      <!-- Feature Grid -->
      <div class="grid grid-cols-3 gap-4">
        <button 
          v-for="feature in features" 
          :key="feature.name"
          :class="[ 
            'flex flex-col items-center justify-center p-4 border rounded-lg transition-all',
            selectedFeature === feature.name ? 'bg-blue-50 border-blue-500' : 'hover:bg-gray-100'
          ]"
          @mouseover="hoverFeature = feature.name"
          @mouseleave="hoverFeature = ''"
          @click="selectFeature(feature.name)"
        >
          <span class="bg-gray-200 rounded-full p-2 mb-2">
            <component :is="feature.icon" class="h-8 w-8 text-gray-500"></component>
          </span>
          <span class="text-gray-700 font-semibold">{{ feature.name }}</span>
        </button>
      </div>

      <!-- Select Button -->
      <div class="mt-8">
        <button class="w-64 py-2 px-4 bg-green-500 text-white font-semibold rounded-md hover:bg-green-600 transition-all">
          Add Product To Members Area
        </button>
      </div>
    </aside>

    <!-- Main Content (Feature Preview) -->
    <main class="flex-1 flex flex-col p-8 mt-32">
      <div v-if="selectedFeature" class="flex flex-col items-center text-center space-y-6">
        <!-- Centered and Larger Feature Image -->
        <div class="relative w-[600px] h-auto overflow-hidden">
          <img :src="getFeature(selectedFeature).image" alt="Feature Preview" class="w-full" />
        </div>

        <!-- Feature Name and Description -->
        <div class="w-full max-w-lg">
          <h3 class="text-xl font-semibold text-gray-800">{{ getFeature(selectedFeature).name }}</h3>
          <p class="text-gray-500 mt-4">{{ getFeature(selectedFeature).description }}</p>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import {
  AcademicCapIcon,
  VideoCameraIcon,
  CalculatorIcon,
  ChatBubbleLeftRightIcon,
  GlobeAltIcon,
  ShoppingBagIcon,
  UserGroupIcon,
  QueueListIcon
} from '@heroicons/vue/24/outline';

// Import the local image
import onlineCourseImage from '@/assets/media/images/online-course.png';
import videoChannelImage from '@/assets/media/images/video-channel-platforma-select.png';
import quizzesImage from '@/assets/media/images/quiz.png';
import calculatorImage from '@/assets/media/images/online-course.png';
import groupnewsfeedImage from '@/assets/media/images/newsfeed.png';
import shopifyImage from '@/assets/media/images/shopify.png';
import chatImage from '@/assets/media/images/chat.png';
import webinarImage from '@/assets/media/images/webinar.png';

// Feature data
const features = ref([
  { 
    name: 'Online Course', 
    icon: AcademicCapIcon, 
    image: onlineCourseImage, // Use the imported image here
    description: 'Add This Easy To Follow Digital Learning Course To Your Members Area Application. Set The Feature To Free For Everyone In Your App, OR Charge For Access.' 
  },
  { name: 'Video Channel', icon: VideoCameraIcon, image: videoChannelImage, description: 'Select A Decentralized Video Channel To Your Platform. With All the Elements You and Your Subscribers are Familiar With. Add As Many Channels To Your App As You Like. One is Included with Your Standard Membership.' },
  { name: 'Quizzes', icon: QueueListIcon, image: quizzesImage, description: 'Automate Your Coaching with the Quiz Feature. Super Powerful Tool To Activate Inside Your Platform. Design a Unique Experience For Your Members WITHOUT The Hands On Training. Check The Video Above To Se How It Works.' },
  { name: 'Calculator', icon: CalculatorIcon, image: calculatorImage, description: 'Preconfigure Advanced Solutions and Recipes That Will Spit Out Dynamic Answers For Your Members To Utilize. Just One More Cool Feature To Give Your Platform Additional Value' },
  { name: 'Group Newsfeed', icon: UserGroupIcon, image: groupnewsfeedImage, description: 'Activate This Private Group Style Newsfeed To Your Platform Today, and Create Your Own Community That Your Control. Approve Posts, and Schedule Your Posts To Keep Members Engaged, and Returning To Your Platform. Allow Free Access, or Charge a Fee. Create Additional Groups and Hide Only For Select Members.' },
  { name: 'Storefront', icon: ShoppingBagIcon, image: shopifyImage, description: 'Create a polished, Shopify-like shopping experience inside your member app, with products, checkout, orders, shipping, and fulfillment managed through Platforma.' },
  { name: 'Messenger Chat', icon: ChatBubbleLeftRightIcon, image: chatImage, description: 'Coaching People One-on-One? Than this feature is definitely for you. Drop The Messenger Feature in Your App, and Never leave anyone hangin. Get Quick Solutions to Problems Avoiding Chargebacks.' },
  { name: 'Webinar', icon: GlobeAltIcon, image: webinarImage, description: 'Run Private Member Webinars With Your Course to Earn Profits On Demand. Live stream to your audience within your private members area.' }
]);

// State for hovering and selecting
const hoverFeature = ref('');
const selectedFeature = ref('Online Course');

// When a feature is clicked, it becomes selected
const selectFeature = (featureName) => {
  selectedFeature.value = featureName;
};

// Function to get details of a feature
const getFeature = (featureName) => {
  return features.value.find(feature => feature.name === featureName);
};
</script>

<style scoped>
/* Custom styles can be added here if needed */
</style>
